import { ComponentPropsWithoutRef, ReactNode } from "react";
import * as styles from "./styles";

export interface ColorCardProps extends ComponentPropsWithoutRef<"div"> {
  title: string;
  hex: string;
  rgb: string;
  icon: ReactNode;
  iconSize?: "middle" | "large";
}

export const ColorCard = ({
  title,
  hex,
  rgb,
  icon,
  iconSize = "middle",
  ...props
}: ColorCardProps) => {
  return (
    <div css={styles.card} {...props}>
      <div css={[styles.icon, iconSize === "large" && styles.iconLarge]}>
        {icon}
      </div>
      <div>
        <p css={styles.title}>{title}</p>
        <p css={styles.hex}>{hex}</p>
        <p css={styles.rgb}>{rgb}</p>
      </div>
    </div>
  );
};
